import styles from './index.module.scss';
import { PropTypes } from 'prop-types';

const FilledButton = ({ text, as: Component = 'button', ...props }) => {
  return (
    <Component {...props}>
      <span className={`${styles.button} uppercase`}>{text}</span>
    </Component>
  );
};

FilledButton.propTypes = {
  text: PropTypes.string.isRequired,
  as: PropTypes.elementType,
};

export default FilledButton;
